// ============================================================
// TMR Portal Admin — as colunas da planilha de Partes
// ============================================================
import { maskCPF } from '../../lib/format';
import { displayPhone } from '../../lib/phone';
import type { PartyListItem } from '../../data/parties/contract';
import type { ExportColumn } from '../../lib/export/types';

/**
 * The Parties directory as a spreadsheet (20 §9).
 *
 * The CPF goes out masked, as the table shows it — the raw digits are the API's shape, not the reader's.
 * `companyCount` stays a number: "quem não está ligado a nenhuma Empresa" is the question this list gets
 * exported to answer, and a number is what Excel can filter on.
 */
export const PARTY_EXPORT_COLUMNS: ExportColumn<PartyListItem>[] = [
  { header: 'Nome', value: (p) => p.name },
  { header: 'CPF', value: (p) => (p.cpf ? maskCPF(p.cpf) : '') },
  { header: 'E-mail', value: (p) => p.email ?? '' },
  { header: 'Telefone', value: (p) => (p.phone ? displayPhone(p.phone) : '') },
  { header: 'Situação', value: (p) => (p.active ? 'Ativa' : 'Arquivada') },
  { header: 'Empresas vinculadas', value: (p) => p.companyCount },
];
